// src/routes/Admin.js

import React from 'react';
import { useAuth } from '../../hooks/useAuth';
import AppLayout from '../../components/layout/AppLayout';

// 子コンポーネント (開発者向けツール) を読み込む
import Developer from './Developer';

function Admin() {
  // 認証とトークン管理
  const { user: currentUser, loading: authLoading } = useAuth();

  return (
    <AppLayout>
      <Developer />
    </AppLayout>
  );
}

export default Admin;
